import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Button } from '../Button';
import styles from './accordion-tw-styles';
import Expanded from './ExpandMore';
import Collapsed from './ExpandLess';
import i18nMessages from '../../../constants/messages/pt-BR';
import { navigationHeaders, filterHeaders } from '../../../constants/global';

export default class AccordionPanelHeader extends React.Component {
  constructor(props) {
    super(props);
  }

  state = {
    collapsible: false, // this is show the behaviour
  };

  componentDidMount = () => {
    let width = window.innerWidth;
    const {
      smartphoneWidth,
      smartphoneCollapsible,
      desktopCollapsible,
    } = this.props;
    if (width <= smartphoneWidth) {
      this.setState({ collapsible: smartphoneCollapsible });
    }

    if (width > smartphoneWidth) {
      this.setState({ collapsible: desktopCollapsible });
    }
  };

  componentWillUnmount = () => {
    window.removeEventListener(i18nMessages.resize, this.handleResize);
  };

  static defaultProps = {
    isExpanded: true,
    accordionStyle: styles,
    className: '',
    expanded: <Expanded />,
    collapsed: <Collapsed />,
    desktopCollapsible: true,
    smartphoneCollapsible: true,
    smartphoneWidth: 991,
    ariaLabel: undefined,
  };

  render() {
    const {
      className,
      accordionStyle,
      expanded,
      collapsed,
      children,
      panelIndex,
      handleClick,
      isExpanded,
      ariaLabel,
      submenuItemCount,
    } = this.props;
    const { collapsible } = this.state;
    let accordionStyles = {};
    if (accordionStyle !== undefined) {
      accordionStyles = accordionStyle;
    } else {
      accordionStyles = styles;
    }
    if (!collapsible) {
      return <div className={className}>{children}</div>;
    }

    const extractText = node => {
      if (node === null || node === undefined) return '';
      if (typeof node === 'string' || typeof node === 'number') {
        return String(node);
      }
      if (Array.isArray(node)) {
        return node.map(extractText).join(' ');
      }
      if (node && node.props && node.props.children) {
        return extractText(node.props.children);
      }
      return '';
    };

    const normalizeHeaderText = value =>
      String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim()
        .toUpperCase();

    const headerText = normalizeHeaderText(extractText(children));
    const isFilterHeader =
      headerText === filterHeaders.TIPO_DE_CABELO ||
      headerText === filterHeaders.NECESSIDADE_DO_CABELO ||
      headerText === filterHeaders.TIPO_DE_PRODUTO ||
      headerText === filterHeaders.COLECOES;

    // Recursively search for h4 text in children
    const findH4Text = (node) => {
      if (!node) return null;
      
      // Check if this is an h4 element
      if (node?.props?.className?.includes('footerHeader')) {
        return node?.props?.children;
      }
      
      // Recursively search in children
      if (node?.props?.children) {
        if (Array.isArray(node.props.children)) {
          for (let child of node.props.children) {
            const result = findH4Text(child);
            if (result) return result;
          }
        } else {
          return findH4Text(node.props.children);
        }
      }
      
      return null;
    };

    // Extract h4 text for dynamic aria-label
    const getAriaLabelFromChildren = () => {
      if (ariaLabel) return ariaLabel;
      
      try {
        const h4Text = findH4Text(children);
        const hasSubmenuCount = Number.isInteger(submenuItemCount);
        if (h4Text === navigationHeaders.SOBRE_NOS) {
          const count = hasSubmenuCount ? submenuItemCount : navigationHeaders.SOBRE_NOS_DEFAULT_COUNT;
          return navigationHeaders.getAriaLabel(navigationHeaders.SOBRE_NOS, count);
        } else if (h4Text === navigationHeaders.NOVIDADES) {
          const count = hasSubmenuCount ? submenuItemCount : navigationHeaders.NOVIDADES_DEFAULT_COUNT;
          return navigationHeaders.getAriaLabel(navigationHeaders.NOVIDADES, count);
        }
      } catch (e) {
        // If unable to extract, use default
      }

      return navigationHeaders.DEFAULT_SUBMENU_ARIA_LABEL;
    };
    
    return (
      <div
        role="presentation"
        onKeyPress={() => handleClick(panelIndex)}
        className={classNames(accordionStyles.accordion.panelHeader, className)}
        onClick={() => handleClick(panelIndex)}
      >
        {isFilterHeader ?
          <button href="javascript:void(0)"
            aria-label={`categoria ${children?.props?.children?.props?.children || ''}`}
            onClick={() => handleClick(panelIndex)}
            onKeyDown={(e) => {
              if(e.key==='Enter'){
                handleClick(panelIndex)
              }
            }}
            aria-expanded={isExpanded ? true : false}
            data-action-detail={headerText}
            className={isExpanded ? 'navigation_arrow icon-arrow-up-light' : ' navigation_arrow icon-arrow-down-light'}>
            {extractText(children)}
          </button>
          : children?.props.children[0]?.props.children == "Organizar por" ?
            <Button href="javascript:void(0)" aria-haspopup={true} role="button"
              aria-expanded={isExpanded ? true : false}>
              {isExpanded ? (
                <span className={classNames(accordionStyles.accordion.icon)}>
                  {collapsed}
                </span>
              ) : (
                <span className={classNames(accordionStyles.accordion.icon)}>
                  {expanded}
                </span>
              )}
              {children}
            </Button>


            :
            <Button 
              aria-label={getAriaLabelFromChildren()} 
              aria-haspopup={true} 
              {...(typeof window !== 'undefined' && window.innerWidth < 1024 ? { 'aria-expanded': isExpanded ? true : false } : {})}
              role="button"
              href="javascript:void(0)"
            >
              {isExpanded ? (
                <span className={classNames(accordionStyles.accordion.icon)}>
                  {collapsed}
                </span>
              ) : (
                <span className={classNames(accordionStyles.accordion.icon)}>
                  {expanded}
                </span>
              )}
              {children}
            </Button>
        }
      </div>
    );
  }
}

AccordionPanelHeader.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  isExpanded: PropTypes.bool,
  accordionStyle: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.shape({
      accordion: PropTypes.object,
      accordionStory: PropTypes.object,
    }),
  ]),
  expanded: PropTypes.element,
  collapsed: PropTypes.element,
  desktopCollapsible: PropTypes.bool,
  smartphoneCollapsible: PropTypes.bool,
  smartphoneWidth: PropTypes.number,
  handleClick: PropTypes.func.isRequired,
  panelIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  ariaLabel: PropTypes.string,
  submenuItemCount: PropTypes.number,
};

// TODO(next16): defaultProps removed in React 19 for function components.
// Convert to inline parameter defaults: const AccordionPanelHeader = ({prop = val, isExpanded = true, accordionStyle = styles, className = '', expanded = <Expanded />, collapsed = <Collapsed />, desktopCollapsible = true, smartphoneCollapsible = true, smartphoneWidth = 991 }) =>
AccordionPanelHeader.defaultProps = {
  isExpanded: true,
  accordionStyle: styles,
  className: '',
  expanded: <Expanded />,
  collapsed: <Collapsed />,
  desktopCollapsible: true,
  smartphoneCollapsible: true,
  smartphoneWidth: 991,
};
